import { Drawer } from 'almanac-ui/Drawer/Drawer'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import Styles from '../Panels.module.scss'
import { LazyComponentWrapper } from 'components/LazyComponentWrapper/LazyComponentWrapper'
import { Heading } from 'blaze-ui/Heading/Heading'
import { PlagiarismCheck, SEOAnalysis as SEOAnalysisIcon } from 'blaze-ui/icons/36'
import { Text } from 'blaze-ui/Text/Text'
import { ArrowRight } from 'blaze-ui/icons'
import { lazyRetry } from 'utils/lazyRetry'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'

const SEOAnalysis = lazyRetry(() => import('../../../SEOAnalysis/SEOAnalysis'))

export const SEOAnalysisPanel = observer(() => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const rightRailPanelStore = useRootStore().rightRailPanelStore

  return (
    <>
      <Drawer.Header>
        <div className={Styles.header}>
          <div className={Styles.headerInner}>
            {!isSystemRedesignEnabled && <SEOAnalysisIcon size={20} />}
            {isSystemRedesignEnabled ? <Text>SEO Analysis</Text> : <Heading level={4}>SEO Analysis</Heading>}
          </div>
          <Drawer.CloseButton />
        </div>
      </Drawer.Header>
      <Drawer.Body>
        <LazyComponentWrapper
          component={
            <SEOAnalysis>
              {!isSystemRedesignEnabled && (
                <div className={Styles.nextStepButton} onClick={() => rightRailPanelStore.show('plagiarism')}>
                  <PlagiarismCheck />
                  <div className={Styles.nextAction}>
                    <Text variant="label">Next step</Text>
                    <Heading level={5}>Check for Plagarism</Heading>
                  </div>
                  <div className={Styles.arrowRight}>
                    <ArrowRight />
                  </div>
                </div>
              )}
            </SEOAnalysis>
          }
        />
      </Drawer.Body>
    </>
  )
})
